import { Alert, Divider, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import Answer from "./Answer";
import useAuditStore from "./useAuditStore";
import PatientNav from "./PatientNav";
import SwitchButton from "./SwitchButton";
import Results from "./Results";


export default function Grid(){

    const {audit, showResults, tab} = useAuditStore();

    if(showResults) return <Results />

    return  <>

        {tab === 'initial' &&
            <Alert severity='info' sx={{mb: 1}}>
                Pour réaliser l'audit clinique initial, sélectionner une dizaine de dossiers patients, les plus récents concernés par la thématique de la formation, sauf dans le cas où le nombre de dossiers est inférieur à 10, la totalité des dossiers concernés est alors prise en compte dans l’évaluation. Pour chaque dossier, répondez aux questions ci-dessous avec 3 réponses possibles "OUI", "NON" ou "NA" pour Non Applicable.
                <br/>
                <br/>
                Cliquez sur le bouton "Suivant" pour renseigner un nouveau dossier, et sur le bouton "Voir les résultats" pour l'analyse de vos pratiques cliniques.
            </Alert>
        }

        {tab === 'final' &&
            <Alert severity='info' sx={{mb: 1}}>
                Pour réaliser l'audit clinique final, sélectionnez une dizaine de dossiers patients, les plus récents concernés par la thématique de la formation, sauf dans le cas où le nombre de dossiers est inférieur à 10, la totalité des dossiers concernés est alors prise en compte dans l’évaluation. Pour chaque dossier, répondez aux questions ci-dessous avec 3 réponses possibles "OUI", "NON" ou "NA" pour Non Applicable.
                <br/>
                <br/>
                Cliquez sur le bouton "Suivant" pour renseigner un nouveau dossier, et sur le bouton "Voir les résutlats" pour l'analyse de vos pratiques cliniques.
            </Alert>
        }

        <Paper variant='outlined'>

            <PatientNav />

            <Divider />

            <TableContainer>
                <Table>
                    <TableBody>
                        {audit.map((row, i) =>
                            <TableRow key={row.id}>

                                <TableCell sx={cellSx}>
                                    <b>{i + 1}.</b>
                                </TableCell>

                                <TableCell sx={cellSx}>
                                    {row.question?.title}
                                </TableCell>

                                <TableCell sx={cellSx}>
                                    <Answer row={row} />
                                </TableCell>

                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            <PatientNav />

        </Paper>

        <SwitchButton />

    </>;
}

const cellSx = {py: 2, px: 0.5};